import { useEffect } from 'react'

import { migrateLegacyPushWorker } from '@/lib/pwa/push'

/**
 * Runs the f472f9a push-worker migration once per app load, not only when the
 * notifications screen mounts. A legacy `/push/` subscription that survives
 * keeps receiving the same pushes as the root worker, so a dismissed browser
 * notification can reappear from the second delivery (D-080). The migration
 * never prompts for permission and is a no-op when push is unsupported or a
 * legacy registration does not exist.
 */
export function usePushMaintenance(): void {
  useEffect(() => {
    void migrateLegacyPushWorker()
  }, [])
}
